import React,{useState} from "react";
import {C,fmt,filterByDate,dlCSV} from "../utils/constants";
import {Card,Btn} from "./UI";

function BankRecon({pays,dateFrom,dateTo,fmt,C,dlCSV,accounts}){
  const [bankData,setBankData]=React.useState([]);
  const [matched,setMatched]=React.useState({});
  const [uploaded,setUploaded]=React.useState(false);
  const [selAccId,setSelAccId]=React.useState("");

  const filterByDate=(records,from,to)=>{
    if(!from&&!to)return records;
    return records.filter(r=>{const d=r.date||"";if(from&&d<from)return false;if(to&&d>to)return false;return true;});
  };

  const bankAccounts=(accounts||[]).filter(a=>a.type!=="cash");
  // Only compare against payments that actually went into the selected bank account —
  // otherwise cash payments and other accounts' payments would show up as false mismatches.
  const dateFiltered=filterByDate(pays,dateFrom,dateTo);
  const fPays=selAccId ? dateFiltered.filter(p=>p.account_id===selAccId) : dateFiltered;

  const parseBank=e=>{
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        const lines=ev.target.result.split("\n").filter(l=>l.trim());
        const headers=lines[0].split(",").map(h=>h.trim().replace(/"/g,"").toLowerCase());
        const rows=lines.slice(1).map(line=>{
          const vals=line.split(",").map(v=>v.trim().replace(/"/g,""));
          const obj={};headers.forEach((h,i)=>obj[h]=vals[i]||"");
          return{date:obj.date||obj["value date"]||"",desc:obj.description||obj.narration||obj.particulars||"",credit:+obj.credit||+obj["credit amount"]||0,debit:+obj.debit||+obj["debit amount"]||0,balance:+obj.balance||0};
        }).filter(r=>r.date&&(r.credit>0||r.debit>0));
        setBankData(rows);setUploaded(true);setMatched({});
      }catch(e){alert("CSV format galat! Date, Description, Credit, Debit columns chahiye.");}
    };
    reader.readAsText(file);
  };

  const autoMatch=()=>{
    const m={};
    const usedPayIndices=new Set(); // prevents the same payment being matched to more than one bank entry
    bankData.forEach((b,bi)=>{
      // Prefer an exact date+amount match first
      let foundPi=fPays.findIndex((p,pi)=>!usedPayIndices.has(pi) && Math.abs(b.credit-(+p.amt||0))<1 && b.date===p.date);
      // Fall back to an amount-only match only if no exact match exists
      if(foundPi===-1){
        foundPi=fPays.findIndex((p,pi)=>!usedPayIndices.has(pi) && Math.abs(b.credit-(+p.amt||0))<1);
      }
      if(foundPi!==-1){
        m[bi]=foundPi;
        usedPayIndices.add(foundPi);
      }
    });
    setMatched(m);
  };

  const totalCredit=bankData.reduce((s,b)=>s+b.credit,0);
  const totalPays=fPays.reduce((s,p)=>s+(+p.amt||0),0);
  const diff=totalCredit-totalPays;
  const matchedCount=Object.keys(matched).length;
  const unmatchedBank=bankData.filter((_,i)=>matched[i]===undefined);
  const matchedPIs=Object.values(matched);
  const unmatchedPays=fPays.filter((_,i)=>!matchedPIs.includes(i));

  return <div>
    <div style={{fontSize:13,fontWeight:700,marginBottom:4}}>🏦 Bank Reconciliation</div>
    <div style={{fontSize:11,color:C.sub,marginBottom:9}}>Bank statement upload karo — app ke payments se match karo</div>

    {bankAccounts.length>0&&<div style={{marginBottom:10}}>
      <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>Kaunsa Bank Account Reconcile Karna Hai?</div>
      <select value={selAccId} onChange={e=>setSelAccId(e.target.value)} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:13,background:"#fff",fontFamily:"inherit"}}>
        <option value="">-- Sabhi Payments (account-wise filter nahi) --</option>
        {bankAccounts.map(a=><option key={a.id} value={a.id}>🏦 {a.name}</option>)}
      </select>
      {!selAccId&&<div style={{fontSize:10,color:C.warning,marginTop:4}}>⚠️ Koi account select nahi kiya — sab payments (cash bhi) compare honge, isse galat mismatch dikh sakte hain</div>}
    </div>}

    {!uploaded?<div>
      <Card style={{marginBottom:10,background:"#F0F9FF",borderLeft:`4px solid ${C.info}`}}>
        <div style={{fontWeight:700,fontSize:12,color:C.info,marginBottom:5}}>📋 Bank Statement CSV Format</div>
        <code style={{fontSize:10,background:"#fff",padding:"6px 9px",borderRadius:6,display:"block",fontFamily:"monospace",marginBottom:7}}>Date, Description, Credit, Debit, Balance</code>
        <div style={{fontSize:10,color:C.sub}}>Most banks ka CSV statement yahi format mein hota hai. Net banking se download karo.</div>
      </Card>
      <label style={{display:"block",border:`2px dashed ${C.primary}`,borderRadius:12,padding:"25px",textAlign:"center",cursor:"pointer",background:"#F0F9FF"}}>
        <input type="file" accept=".csv" onChange={parseBank} style={{display:"none"}}/>
        <div style={{fontSize:32,marginBottom:8}}>🏦</div>
        <div style={{fontWeight:700,color:C.primary,fontSize:13}}>Bank Statement CSV Upload Karo</div>
        <div style={{fontSize:11,color:C.sub,marginTop:3}}>HDFC, SBI, ICICI, Axis — sab supported</div>
      </label>
    </div>:<div>
      {/* Summary Cards */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:10}}>
        <div style={{background:C.success+"15",borderRadius:9,padding:"9px",textAlign:"center"}}><div style={{fontSize:14,fontWeight:800,color:C.success}}>₹{fmt(totalCredit)}</div><div style={{fontSize:9,color:C.sub}}>Bank Credits</div></div>
        <div style={{background:C.primary+"15",borderRadius:9,padding:"9px",textAlign:"center"}}><div style={{fontSize:14,fontWeight:800,color:C.primary}}>₹{fmt(totalPays)}</div><div style={{fontSize:9,color:C.sub}}>App Payments</div></div>
        <div style={{background:(Math.abs(diff)<1?C.success:C.danger)+"15",borderRadius:9,padding:"9px",textAlign:"center"}}><div style={{fontSize:14,fontWeight:800,color:Math.abs(diff)<1?C.success:C.danger}}>₹{fmt(Math.abs(diff))}</div><div style={{fontSize:9,color:C.sub}}>{Math.abs(diff)<1?"✅ Matched":"Difference"}</div></div>
      </div>

      <div style={{display:"flex",gap:7,marginBottom:10,flexWrap:"wrap"}}>
        <Btn ch="🤖 Auto Match" oc={autoMatch} color={C.primary} sm/>
        <Btn ch="🔄 Reset" oc={()=>{setBankData([]);setUploaded(false);setMatched({});}} color={C.sub} out sm/>
        <Btn ch="⬇️ Report CSV" oc={()=>{
          const rows=[
            ["=== MATCHED ==="],
            ["Date","Bank Description","Amount","App Payment","Customer"],
            ...bankData.filter((_,i)=>matched[i]!==undefined).map((b,i)=>{const p=fPays[matched[bankData.indexOf(b)]];return[b.date,b.desc,b.credit,p?.amt||"",p?.cust||""];}),
            [""],["=== UNMATCHED BANK ==="],
            ["Date","Description","Credit"],
            ...unmatchedBank.map(b=>[b.date,b.desc,b.credit]),
            [""],["=== UNMATCHED APP PAYMENTS ==="],
            ["Date","Customer","Amount","Method"],
            ...unmatchedPays.map(p=>[p.date,p.cust,p.amt,p.method])
          ];
          dlCSV("bank_reconciliation.csv",["Col1","Col2","Col3","Col4","Col5"],rows);
        }} color={C.success} sm/>
      </div>

      <div style={{fontSize:11,fontWeight:700,color:C.sub,marginBottom:5}}>📊 {matchedCount}/{bankData.length} entries matched</div>

      {/* Unmatched Bank Entries */}
      {unmatchedBank.length>0&&<Card style={{marginBottom:9,borderLeft:`3px solid ${C.danger}`}}>
        <div style={{fontWeight:700,fontSize:11,color:C.danger,marginBottom:7}}>❌ Unmatched Bank Entries ({unmatchedBank.length})</div>
        {unmatchedBank.map((b,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${C.border}`,fontSize:11}}>
          <div><div style={{fontWeight:600}}>{b.desc.slice(0,30)}</div><div style={{fontSize:9,color:C.sub}}>{b.date}</div></div>
          <div style={{fontWeight:700,color:C.success}}>+₹{fmt(b.credit)}</div>
        </div>)}
      </Card>}

      {/* Unmatched App Payments */}
      {unmatchedPays.length>0&&<Card style={{borderLeft:`3px solid ${C.warning}`}}>
        <div style={{fontWeight:700,fontSize:11,color:C.warning,marginBottom:7}}>⚠️ App Payments Not in Bank ({unmatchedPays.length})</div>
        {unmatchedPays.map((p,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${C.border}`,fontSize:11}}>
          <div><div style={{fontWeight:600}}>{p.cust}</div><div style={{fontSize:9,color:C.sub}}>{p.date} • {p.method}</div></div>
          <div style={{fontWeight:700,color:C.primary}}>₹{fmt(p.amt)}</div>
        </div>)}
      </Card>}
    </div>}
  </div>;
}

// ── Main App ────────────────────────────────────────────────────────

export default BankRecon;
